import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="py-20 px-4 bg-brand-card/50 border-t border-white/5 text-center" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        <span className="text-5xl mb-6 block" data-id="element-77">🚀</span>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-78">
          Si sigues haciendo lo mismo… vas a seguir en el mismo lugar
        </h2>

        <p className="text-xl text-gray-300 mb-2" data-id="element-79">
          Puedes seguir dependiendo de tu tiempo…
        </p>
        <p className="text-2xl font-bold text-brand-gold mb-10" data-id="element-80">
          O empezar a construir algo que escale.
        </p>

        <a href="https://elrincondigital.click/checkouts/cn/hWNAo7z75maXKkG1F9Tv4tAg/es-ar?_r=AQABSkl_EFQxzGD_FUgSwkK30K4-GLFlFaSWe9naqJX1U9E&preview_theme_id=154785841310" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-brand-green hover:bg-green-600 text-white font-bold text-2xl py-5 px-12 rounded-xl shadow-[0_0_30px_rgba(0,146,70,0.5)] hover:shadow-[0_0_50px_rgba(0,146,70,0.8)] transition-all transform hover:scale-105 mb-8" data-id="element-81">
          👉 Quiero empezar ahora
        </a>

        <div className="flex justify-center" data-id="element-82">
          <CountdownTimer size="md" data-id="element-83" />
        </div>
      </div>
    </section>;
}